<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('little jar records')"
      :columns="columns"
      :column_search="true"
      resource_url="/little_jar/record/datatables"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/little_jar/settings' })"
        >
          <span class="icon"><i class="fa fa-glass"></i></span>
          <span>{{ $t("little jars") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <record-modal ref="record_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import RecordModal from "../record_modal/Index.vue";

export default {
  name: "LittleJarRecordsDatatable",
  components: { GenericTable, RecordModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          width: "15%",
          data: (row) => {
            return format_date(row.date);
            //return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
          },
        },
        {
          title: v.$t("little jar"),
          searchable: false,
          width: "25%",
          data: (row) => {
            return row.little_jar.name;
            //return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
          },
        },
        {
          title: v.$t("patient"),
          searchable: true,
          width: "25%",
          data: (row) => {
            return row.patient;
            //return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
          },
        },
        {
          title: v.$t("symptoms"),
          searchable: true,
          width: "25%",
          data: (row) => {
            return row.symptoms;
            //return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$refs.record_modal.show_modal(uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete record?"),
                    v,
                    () => {
                      del("/little_jar/record", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.record_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
